module.exports = __webpack_public_path__ + "static/media/1.568f3a7f.png";